const observer = new MutationObserver(function(mutations) {
    const redoApp = document.querySelector("redo-shopify-toggle")
    if (redoApp) {
        observer.disconnect()
        console.log("Redo app loaded2", redoApp)

        const shadowRoot = redoApp.shadowRoot
        if (shadowRoot) {
            const styleElement = document.createElement("style")
            styleElement.textContent = `
              [data-target="non-coverage-button"],
              [data-target="non-coverage-button"]:hover,
              [data-target="coverage-button"],
              [data-target="coverage-button"]:hover {
                border-radius: 15px !important;
                height: 58px !important;
              }
              [data-target="info-card-container"] {
                margin-top: 3px !important;
              }
              [data-target="non-coverage-button"] > p,
              [data-target="coverage-button"] * {
                font-size: 17px !important;
                font-weight: 500 !important;
                font-family: "Inter", sans-serif !important;
              }
              [data-target='toggle-subtext'] {
                font-size: 13px !important;
                font-weight: 400 !important;
                font-family: "Inter", sans-serif !important;
              }
              [data-target='toggle-label'] {
                font-size: 16px !important;
                font-weight: 500 !important;
                margin-bottom: 4px !important;
                font-family: "Inter", sans-serif !important;
                display: inline-block !important;
              }
              [data-target="text-and-buttons-container"] {
                display: flex !important;
                align-items: end !important;
              }
              [data-target="price"] {
                font-size: 0.95em !important;
                height: 100%;
                display: flex;
                align-items: end;
              }
            `
            shadowRoot.appendChild(styleElement)
        }
    } else {
        console.log("Redo app not loaded")
    }
})

observer.observe(document.body, {
    childList: true,
    subtree: true
})

const openCartDrawer = (e) => {
    if (e && typeof e.preventDefault === 'function') {
        e.preventDefault();
    }
    const cartContainer = document.querySelector("#shopify-section-cart-drawer")
    if (cartContainer) {
        cartContainer.classList.add("active")
        
        // --- Advanced Scroll Lock ---
        const scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
    }
}

const closeCartDrawer = () => {
    const cartContainer = document.querySelector("#shopify-section-cart-drawer")
    if (cartContainer) {
        cartContainer.classList.remove("active")
        
        // --- Advanced Scroll Unlock ---
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
}

function ajaxSubmitCart(cart) {
    const $cart = cart
    $.ajax({
        url: "/cart/update.js",
        dataType: "json",
        cache: false,
        type: "post",
        data: $cart.serialize(),
        success(data) {
            refreshCartWithSectionRendering()
        }
    })
}

// --- NEW: Visual function to dim the plus button when max inventory is reached ---
function applyInventoryOpacities() {
    $(".custom-quantity-input").each(function() {
        let $input = $(this);
        let currentVal = parseInt($input.val());
        let maxVal = parseInt($input.attr("max"));
        let $plusBtn = $input.siblings('.custom-change-quantity[data-func="plus"]');
        
        if (!isNaN(maxVal) && currentVal >= maxVal) {
            $plusBtn.css({ "opacity": "0.3", "cursor": "not-allowed" });
        } else {
            $plusBtn.css({ "opacity": "1", "cursor": "pointer" });
        }
    });
}

function updateCartItemQuantity(cartItem) {
    $.ajax({
        url: "/cart/change.js",
        dataType: "json",
        cache: false,
        type: "post",
        data: {
            quantity: cartItem.quantity,
            line: cartItem.lineID
        },
        success(data) {
            const cartItemsArray = data.items
            const lineIDIndex = cartItem.lineID - 1
            const totalCartItems = cartItem.parentCartForm.find("[data-variant-id]").length
            const $quantityInputs = cartItem.parentCartForm.find(
                `[data-variant-id="${cartItem.variantID}"] input`
            )
            let initialQuantityTotal = 0
            let apiQuantityTotal = 0
            const apiLineItemQuantity =
                typeof data.items[lineIDIndex] !== "undefined" ? data.items[lineIDIndex].quantity : 0

            if ($quantityInputs.length > 1) {
                $.each($quantityInputs, (_i, input) => {
                    initialQuantityTotal += parseInt($(input).val())
                })
                cartItemsArray.forEach(item => {
                    if (item.variant_id === cartItem.variantID) {
                        apiQuantityTotal += item.quantity
                    }
                })
            } else {
                initialQuantityTotal = parseInt($quantityInputs.val())
                apiQuantityTotal =
                    typeof data.items[lineIDIndex] !== "undefined" ? data.items[lineIDIndex].quantity : 0
            }

            if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
                if (apiQuantityTotal === 1) {
                    itemsLeftText = window.PXUTheme.translation.one_item_left || "item left";
                } else {
                    itemsLeftText = window.PXUTheme.translation.items_left_text || "items left";
                }

                $(".warning--quantity").remove()

                if (totalCartItems < cartItemsArray.length) {
                    if (cartItem.parentCartForm.data("cart-form") === "cart-template") {
                        cartItem.parentCartForm.submit()
                    } else {
                        refreshCartWithSectionRendering()
                    }
                } else {
                    const warning = `<p class="warning warning--quantity animated bounceIn" style="font-size: 11px; color: #c82128; margin-top: 5px; text-align: right; width: 100%;">Only ${apiQuantityTotal} ${itemsLeftText}</p>`
                    
                    const $inputEl = cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`);
                    
                    $inputEl.parent().after(warning);
                    $inputEl.val(apiLineItemQuantity);
                    
                    // Un-freeze the buttons if an error is caught!
                    $inputEl.siblings(".custom-change-quantity").css("pointer-events", "auto").css("opacity", "1");
                    
                    // Re-apply the dimming logic in case we snapped back to max inventory
                    applyInventoryOpacities();
                }
            } else if (cartItem.parentCartForm.data("cart-form") === "cart-template") {
                cartItem.parentCartForm.submit()
            } else {
                refreshCartWithSectionRendering()
            }
        }
    })
}

function refreshCartID() {
    const cartItem = document.querySelectorAll(".cart__item")
    for (let i = 0; i < cartItem.length; i++) {
        const lineIndex = i + 1
        const dataLineId = cartItem[i].querySelectorAll("[data-line-id]")
        for (let c = 0; c < dataLineId.length; c++) {
            dataLineId[c].dataset.lineId = lineIndex
        }
    }
}

function refreshCartWithSectionRendering() {
    fetch("/cart.js")
        .then(response => response.json())
        .then(cart => {
            const $cartBtn = $(".cart_count")
            const value = $cartBtn.text() || "0"
            $cartBtn.text(value.replace(/[0-9]+/, cart.item_count))
            return fetch(`${window.location.pathname}?sections=cart-drawer`)
        })
        .then(response => response.json())
        .then(sections => {
            const cartDrawerHTML = sections["cart-drawer"]
            const $cartDrawer = $("#shopify-section-cart-drawer")
            
            // --- NEW: Safe HTML Parsing to avoid script re-execution crashes ---
            const parser = new DOMParser();
            const doc = parser.parseFromString(cartDrawerHTML, 'text/html');
            const $newCartDrawer = $(doc).find(".cart-drawer");

            // --- Check if pending code actually rendered in the HTML ---
            const pendingCode = sessionStorage.getItem('pending_discount_code');
            if (pendingCode) {
                let codeFound = false;
                $newCartDrawer.find('.discount-pill__code').each(function() {
                    if ($(this).text().trim().toLowerCase() === pendingCode.toLowerCase()) {
                        codeFound = true;
                    }
                });

                if (codeFound) {
                    sessionStorage.setItem('discount_message', `Code '${pendingCode}' applied!`);
                    sessionStorage.setItem('discount_code', pendingCode);
                } else {
                    sessionStorage.setItem('discount_error', `Code '${pendingCode}' is invalid. Note: Gift cards must be applied at checkout.`);
                    sessionStorage.removeItem('discount_code'); // Clear the bad code
                }
                sessionStorage.removeItem('pending_discount_code');
            }
            // ----------------------------------------------------------------

            $cartDrawer.find(".cart-drawer").replaceWith($newCartDrawer)
            
            bindCartDrawerEvents()
            restoreDiscountCode() // Restore UI after HTML resets
            applyInventoryOpacities() // Assess inventory limits right after drawing the cart

            if (window.PXUTheme.currency && window.PXUTheme.currency.show_multiple_currencies) {
                window.currencyConverter.convertCurrencies()
            }

            openCartDrawer()
        })
        .catch(error => {
            console.error("Error refreshing cart:", error)
        })
}

function bindCartDrawerEvents() {
    const cartClose = document.querySelector(".cart-close")
    if (cartClose) {
        cartClose.removeEventListener("click", closeCartDrawer)
        cartClose.addEventListener("click", closeCartDrawer)
    }

    const overlay = document.querySelector(".cart-overlay")
    if (overlay) {
        overlay.removeEventListener("click", closeCartDrawer)
        overlay.addEventListener("click", closeCartDrawer)
    }
}

// --- Isolated, stealth quantity update logic ---
function handleCustomQuantityUpdate($input) {
    const cartItem = {
        lineID: $input.parents("[data-cart-item]").data("line-id"),
        variantID: $input.parents("[data-cart-item]").data("variant-id"),
        quantity: $input.val(),
        parentCartForm: $input.parents("[data-cart-form]"),
        totalDiscount: $input.parents("[data-cart-form]").data("total-discount"),
        $element: $input.parents("[data-cart-item]")
    };
    
    // Dim buttons temporarily so users don't click too fast
    $input.siblings(".custom-change-quantity").css("pointer-events", "none").css("opacity", "0.5");
    
    updateCartItemQuantity(cartItem);
}

// Handle manual typing in the input box
$("body").on("change", ".custom-quantity-input", function(e) {
    e.preventDefault();
    e.stopImmediatePropagation(); // Force theme scripts to ignore this
    handleCustomQuantityUpdate($(this));
});

// Handle +/- button clicks secretly
$("body").on("click", ".custom-change-quantity", function(e) {
    e.preventDefault();
    e.stopImmediatePropagation(); // Force theme scripts to ignore this
    
    const $input = $(this).siblings(".custom-quantity-input");
    let currentVal = parseInt($input.val());
    
    // Grab the max inventory limit from the input element
    let maxVal = parseInt($input.attr("max")); 
    
    if ($(this).data("func") === "minus") {
        if (currentVal > 0) {
            $input.val(currentVal - 1);
            handleCustomQuantityUpdate($input); // Send directly without triggering "change"
        }
    } else {
        // Block the '+' click if they have reached the inventory limit
        if (!isNaN(maxVal) && currentVal >= maxVal) {
            // Tiny visual shake effect so they know it's blocked
            $input.parent().css("transform", "translateX(2px)");
            setTimeout(() => $input.parent().css("transform", "translateX(0)"), 100);
            return; // Stop right here!
        }
        
        $input.val(currentVal + 1);
        handleCustomQuantityUpdate($input); // Send directly without triggering "change"
    }
});

$("body").on("click", "[data-remove-item]", function(e) {
    e.preventDefault()
    const cartItem = {
        lineID: $(this).parents("[data-cart-item]").data("line-id"),
        variantID: $(this).parents("[data-cart-item]").data("variant-id"),
        quantity: 0,
        parentCartForm: $(this).parents("[data-cart-form]"),
        totalDiscount: $(this).parents("[data-cart-form]").data("total-discount"),
        $element: $(this).parents("[data-cart-item]")
    }

    updateCartItemQuantity(cartItem)

    if (cartItem.parentCartForm.data("cart-form") === "cart-template") {
        cartItem.$element.find("input").val("0")
        cartItem.parentCartForm.submit()
    }

    if (cartItem.parentCartForm.data("cart-form") === "mini-cart") {
        cartItem.$element.find("input").val("0")
    }
})

// --- FORCE AJAX ADD TO CART ---
$(document).on("click", "form[action^='/cart/add'] button[type='submit'], form[action^='/cart/add'] input[type='submit'], .ajax-submit", function(e) {
    e.preventDefault();
    e.stopImmediatePropagation(); 
    
    const $addToCartForm = $(this).closest("form");
    const $addToCartBtn = $(this);

    // If we are actually on the /cart page, just submit normally
    if ($("body").hasClass("cart")) {
        $addToCartForm.submit();
        return false;
    }

    $.ajax({
        url: "/cart/add.js",
        dataType: "json",
        cache: false,
        type: "post",
        data: $addToCartForm.serialize(),
        beforeSend() {
            $addToCartBtn.attr("disabled", "disabled").addClass("disabled");
            $addToCartBtn.find("span").removeClass("fadeInDown").addClass("animated zoomOut");
        },
        success() {
            $addToCartBtn.find(".checkmark").addClass("checkmark-active");
            refreshCartWithSectionRendering();
            window.setTimeout(() => {
                $addToCartBtn.removeAttr("disabled").removeClass("disabled");
                $addToCartBtn.find(".checkmark").removeClass("checkmark-active");
                $addToCartBtn.find("span").removeClass("zoomOut").addClass("fadeInDown");
            }, 1000);

            openCartDrawer();
        },
        error(XMLHttpRequest) {
            let response = eval(`(${XMLHttpRequest.responseText})`);
            response = response.description;
            $(".warning").remove();

            const warning = `<p class="warning animated bounceIn">${response.replace("All 1 ", "All ")}</p>`;
            $addToCartForm.after(warning);
            $addToCartBtn.removeAttr("disabled").removeClass("disabled");
            $addToCartBtn.find("span").text(window.PXUTheme.translation.add_to_cart).removeClass("zoomOut").addClass("zoomIn");
        }
    });

    return false;
});

class CartTrigger extends HTMLElement {
    init() {
        this.addEventListener("click", openCartDrawer)
    }
    connectedCallback() {
        this.init()
    }
}

customElements.define("cart-trigger", CartTrigger)

// ==========================================
// DISCOUNT CODE LOGIC (AJAX Application)
// ==========================================

// 1. APPLY DISCOUNT BUTTON
$("body").on("click", ".js-apply-discount", function(e) {
    e.preventDefault();
    const $container = $(this).closest('.cart-discount-container');
    const code = $container.find('.cart-discount-input').val().trim();
    const $btn = $(this);
    const $message = $container.find('.cart-discount-message');

    if (code) {
        $btn.text('...').css('opacity', '0.7').prop('disabled', true);
        $message.removeClass('success error').text(''); // Clear old messages
        
        fetch(`/discount/${code}`)
            .then(() => {
                // Store as pending instead of blindly trusting Shopify
                sessionStorage.setItem('pending_discount_code', code);
                refreshCartWithSectionRendering();
            })
            .catch(error => {
                console.error('Error applying discount:', error);
                $btn.text('Apply').css('opacity', '1').prop('disabled', false);
            });
    }
});

// 2. REMOVE DISCOUNT BUTTON
$("body").on("click", ".js-remove-discount", function(e) {
    e.preventDefault();
    const $btn = $(this);
    
    // Dim the pill so the user knows it's loading
    $btn.closest('.discount-pill').css('opacity', '0.4').css('pointer-events', 'none');

    // Force-delete Shopify's local discount cookie
    document.cookie = "discount_code=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";

    // Ping the checkout explicitly passing a blank discount parameter. 
    fetch('/checkout?discount=', { mode: 'no-cors' })
        .then(() => {
            // Clear all local storage records of the code
            sessionStorage.removeItem('discount_code');
            sessionStorage.removeItem('discount_message');
            
            // Set a message to let the user know it was wiped
            sessionStorage.setItem('discount_error', 'Discount removed.'); 
            
            // Reload the cart HTML so prices instantly go back to normal
            refreshCartWithSectionRendering();
        })
        .catch(error => {
            console.error('Error clearing discount:', error);
            $btn.closest('.discount-pill').css('opacity', '1').css('pointer-events', 'auto');
        });
});

// 3. RESTORE UI AFTER REFRESH
function restoreDiscountCode() {
    const $input = $('.cart-discount-input');
    const $message = $('.cart-discount-message');
    
    const msg = sessionStorage.getItem('discount_message');
    const errorMsg = sessionStorage.getItem('discount_error');
    const savedCode = sessionStorage.getItem('discount_code');

    // Handle Messages
    if (msg && $message.length) {
        $message.text(msg).removeClass('error').addClass('success');
        sessionStorage.removeItem('discount_message'); 
    } else if (errorMsg && $message.length) {
        $message.text(errorMsg).removeClass('success').addClass('error');
        sessionStorage.removeItem('discount_error');
    }
    
    // Handle Input Field
    if (savedCode && $input.length) {
        $input.val(savedCode);
    } else if (!savedCode && $input.length) {
        $input.val(''); // Empty the field if the code failed
    }
    
    // If a valid code is rendered in the UI from checkout, populate it
    const $appliedDiscountText = $('.discount-pill__code');
    if ($appliedDiscountText.length && $appliedDiscountText.text().trim() !== '') {
        $input.val($appliedDiscountText.first().text().trim());
    }
}

// ==========================================
// INIT DRAWER
// ==========================================
const initCartDrawer = () => {
    const cartClose = document.querySelector(".cart-close")
    const overlay = document.querySelector(".cart-overlay")
    const cartDrawerTrigger = document.querySelectorAll("[data-cart-drawer-trigger]")

    const initTriggers = () => {
        if (cartDrawerTrigger.length > 0) {
            cartDrawerTrigger.forEach(trigger => {
                trigger.removeEventListener("click", openCartDrawer)
                trigger.addEventListener("click", openCartDrawer)
            })
        }
    }

    document.addEventListener("stickyNavInitialized", () => {
        initTriggers()
    })
    
    initTriggers()

    if (cartClose) {
        cartClose.removeEventListener("click", closeCartDrawer)
        cartClose.addEventListener("click", closeCartDrawer)
    }

    if (overlay) {
        overlay.removeEventListener("click", closeCartDrawer)
        overlay.addEventListener("click", closeCartDrawer)
    }
    
    restoreDiscountCode()
    applyInventoryOpacities() // Check limits when the page first loads
}

initCartDrawer()

// ==========================================
// BRUTE FORCE: UNBIND NATIVE THEME CART
// ==========================================
document.addEventListener("DOMContentLoaded", () => {
    // 1. Remove jQuery click events from the header cart icon
    $('a[href="/cart"], .cart-button, .js-cart_btn').off('click');
    
    // 2. Ensure our custom drawer opens instead
    $('a[href="/cart"], .cart-button, .js-cart_btn').on('click', function(e) {
        e.preventDefault();
        openCartDrawer();
    });
});